import React, { useEffect, useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import { UserContext } from "../common/UserContext";
import config from "../../envconfig";
import { Link, useNavigate } from "react-router-dom";
import CustomDropdown from "../common/CustomDropdown";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ShubhamImage from "../../assest/images/Shubham1.png";
import Icon3 from "../../assest/images/Icon3.png";
import Icon8 from "../../assest/images/Icon8.png";
import eye from '../../assest/images/eye.png';
import Icon4 from "../../assest/images/Icon4.png";
import Icon9 from '../../assest/images/Icon9.png';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SchemeList = () => {
    const { UM_CompanyID, selectedScpId, UM_UserId, UM_CompanyGrpID } = useContext(UserContext);
    const navigate = useNavigate();
    /* ================== DATA ================== */
    const [schemes, setSchemes] = useState([]);
    const [filteredSchemes, setFilteredSchemes] = useState([]);
    const [loading, setLoading] = useState(true);

    /* ================== MODAL STATES ================== */
    const [regionPopup, setRegionPopup] = useState(false);
    const [scpPopup, setScpPopup] = useState(false);
    const [productPopup, setProductPopup] = useState(false);
    const [detailPopup, setDetailPopup] = useState(false);

    const [regionNames, setRegionNames] = useState([]);
    const [scpNames, setScpNames] = useState([]);
    const [productList, setProductList] = useState([]);
    const [selectedScheme, setSelectedScheme] = useState(null);

    /* ================== FILTERS & PAGINATION ================== */
    const [firstFilter, setFirstFilter] = useState("");
    const [firstFilterSearch, setFirstFilterSearch] = useState("");
    const [secondFilter, setSecondFilter] = useState("");
    const [secondFilterSearch, setSecondFilterSearch] = useState("");
    const [statusFilterSearch, setStatusFilterSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const baseFilterOptions = [
        { value: "schemeName", label: "Scheme Name" },
        { value: "schemeType", label: "Scheme Type" }
    ];


    // const firstFilterOptions = [
    //     { value: "schemeName", label: "Scheme Name", disabled: false },
    //     { value: "schemeType", label: "Scheme Type", disabled: false },
    //     // { value: "status", label: "Status", disabled: false }
    // ];

    // const [firstFilter, setFirstFilter] = useState("");
    // const [secondFilter, setSecondFilter] = useState("");

    const [firstFilterOptions, setFirstFilterOptions] = useState(
        baseFilterOptions.map(o => ({ ...o, disabled: false }))
    );

    const [secondFilterOptions, setSecondFilterOptions] = useState(
        baseFilterOptions.map(o => ({ ...o, disabled: false }))
    );

    //const [secondFilterOptions, setSecondFilterOptions] = useState([...firstFilterOptions]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const [showAsterisks, setShowAsterisks] = useState({});
    // ----- NEW STATES -------------------------------------------------
    const [firstStatusValue, setFirstStatusValue] = useState("");   // Status dropdown (first filter)
    const [secondStatusValue, setSecondStatusValue] = useState("");  // Status dropdown (second filter)

    const statusOptions = [
        { value: "1", label: "Active" },
        { value: "2", label: "Inactive" },
        { value: "3", label: "Suspend" }
    ];


    /* ================== FETCH ================== */
    useEffect(() => {
        fetchSchemes();
    }, []);

    const fetchSchemes = async () => {
        try {
            const res = await fetch(`${config.API_URL}/Scheme/details`);
            if (!res.ok) throw new Error("Network error");
            const json = await res.json();
            if (json.success) {
                const processed = json.data.map(s => ({
                    ...s,
                    regionNames: s.regions?.join(", ") || "N/A",
                    scpNames: s.scps?.join(", ") || "N/A",
                    productNames: s.products?.map(p => `${p.name} (Qty: ${p.quantity})`).join(", ") || "N/A",
                }));

                setSchemes(processed);
                console.log("Processed", processed)
                setFilteredSchemes(processed);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const generatePdfForScp = async (scheme, scp) => {
        const doc = new jsPDF({ unit: "mm", format: "a4" });

        // ────────────────────── Colours ──────────────────────
        const primary = [41, 90, 128];   // #295A80
        const lightBg = [248, 250, 252];
        const darkText = [30, 30, 30];
        const midText = [70, 70, 70];

        // ────────────────────── Helpers ──────────────────────
        const formatDate = (d) => {
            const date = new Date(d);
            return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
        };
        const safeName = (s) =>
            s.replace(/[^a-zA-Z0-9 ~`!@#$%^&()_+\-=\[\]\\;',.{}]/g, "_");

        // ────────────────────── 1. Header with Logo ──────────────────────
        doc.setFillColor(255, 255, 255);
        doc.rect(0, 0, 210, 38, "F");

        // ---- Logo ----
        const logoRes = await fetch(`${config.API_URL}/logo-base64/${UM_CompanyGrpID}`);
        const logoJson = await logoRes.json();
        const imgData = logoJson.base64 || ShubhamImage;
        doc.addImage(imgData, "PNG", 3, 3, 32, 18);

        const fitText = (text, maxWidth, startingFontSize, minFontSize = 10) => {
            let fontSize = startingFontSize;
            doc.setFontSize(fontSize);

            let width = doc.getTextWidth(text);

            while (width > maxWidth && fontSize > minFontSize) {
                fontSize -= 1;
                doc.setFontSize(fontSize);
                width = doc.getTextWidth(text);
            }

            return fontSize;
        };


        // ---- Title ----
        doc.setTextColor(...primary);
        doc.setFont("helvetica", "bold");

        // Max width allowed for title in mm
        const maxTitleWidth = 160;

        // Dynamically fit font size
        const finalTitleFont = fitText(scheme.schemeName.toUpperCase(), maxTitleWidth, 22);

        // Apply final font size
        doc.setFontSize(finalTitleFont);
        doc.text(scheme.schemeName.toUpperCase(), 105, 25, { align: "center" });


        // ---- Divider line ----
        doc.setDrawColor(...primary);
        doc.setLineWidth(0.8);
        doc.line(0, 32, 240, 32);

        // ────────────────────── 2. Greeting ──────────────────────
        doc.setTextColor(...darkText);
        doc.setFontSize(13);
        doc.text(`To ${scp},`, 20, 48);

        const greeting = scheme.greeting || "We’re delighted to present you with this exclusive scheme!";
        const greetingLines = doc.splitTextToSize(greeting, 170);
        doc.setFontSize(11);
        doc.text(greetingLines, 20, 55);

        // ────────────────────── 3. Validity Banner ──────────────────────
        const start = formatDate(scheme.startDate);
        const end = formatDate(scheme.endDate);

        doc.setFillColor(...lightBg);
        doc.setDrawColor(...primary);
        doc.roundedRect(20, 68, 170, 16, 3, 3, "FD");

        doc.setTextColor(...primary);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(`Scheme Valid : ${start} to ${end}`, 105, 77, { align: "center" });

        // ────────────────────── 4. Products / Offers Layout ──────────────────────
        const schemeType = scheme.schemeType?.toString();
        const detail = scheme.schemeDetails?.[0];
        const productHead = [["Product", "Qty"]];
        const productBody = (scheme.products || []).map(p => [p.name, p.quantity.toString()]);
        const tableStartY = 95;

        // Determine if we have a right section
        const hasRightSection =
            (schemeType === "2" && detail?.freeProducts?.length) ||
            (schemeType === "1" && (scheme.discountPercentage || detail?.discountPercentage)) ||
            (schemeType === "3" && (scheme.giftArticle || detail?.giftArticle));

        // === LEFT: Product Table ===
        let leftTableEndY = tableStartY;

        doc.autoTable({
            startY: tableStartY,
            head: productHead,
            body: productBody,
            theme: "grid",
            margin: hasRightSection ? { left: 20, right: 115 } : { left: 20, right: 20 },
            headStyles: { fillColor: primary, textColor: 255, fontStyle: "bold", halign: "center", fontSize: 11 },
            bodyStyles: { fontSize: 10, cellPadding: 4, halign: "center", textColor: midText },
            styles: { lineColor: [200, 200, 200], lineWidth: 0.2 },
        });

        leftTableEndY = doc.lastAutoTable.finalY;

        // === RIGHT COLUMN: Free / Discount / Gift ===
        let rightColumnEndY = tableStartY; // default same start

        if (hasRightSection) {
            if (schemeType === "2" && detail?.freeProducts?.length) {
                // ─── Free Product Table ───
                const freeHead = [["Free Product", "Qty"]];
                const freeBody = detail.freeProducts.map(fp => [fp.name, fp.quantity.toString()]);

                doc.autoTable({
                    startY: tableStartY,
                    head: freeHead,
                    body: freeBody,
                    theme: "grid",
                    margin: { left: 115, right: 20 },
                    headStyles: { fillColor: primary, textColor: 255, fontStyle: "bold", halign: "center", fontSize: 11 },
                    bodyStyles: { fontSize: 10, cellPadding: 4, halign: "center", textColor: midText },
                    styles: { lineColor: [200, 200, 200], lineWidth: 0.2 },
                });
                rightColumnEndY = doc.lastAutoTable.finalY;

            } else if (schemeType === "1" && (scheme.discountPercentage || detail?.discountPercentage)) {
                // ─── Discount Box (Fixed Height) ───
                const discountValue = scheme.discountPercentage || detail.discountPercentage;
                const boxHeight = 30; // Increased for better spacing
                const boxY = tableStartY;

                doc.setFillColor(...lightBg);
                doc.setDrawColor(...primary);
                doc.roundedRect(115, boxY, 75, boxHeight, 3, 3, "FD");

                doc.setTextColor(...primary);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(13);
                doc.text("DISCOUNT", 152, boxY + 10, { align: "center" });

                doc.setTextColor(...darkText);
                doc.setFontSize(14);
                doc.setFont("helvetica", "normal");
                doc.text(`${discountValue} OFF`, 152, boxY + 22, { align: "center" });

                rightColumnEndY = boxY + boxHeight;

            } else if (schemeType === "3" && (scheme.giftArticle || detail?.giftArticle)) {
                // ─── Gift Article Box ───
                const gift = scheme.giftArticle || detail.giftArticle;
                const boxHeight = 30;
                const boxY = tableStartY;

                doc.setFillColor(...lightBg);
                doc.setDrawColor(...primary);
                doc.roundedRect(115, boxY, 75, boxHeight, 3, 3, "FD");

                doc.setTextColor(...primary);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(13);
                doc.text("GIFT ARTICLE", 152, boxY + 10, { align: "center" });

                doc.setTextColor(...darkText);
                doc.setFontSize(12);
                doc.setFont("helvetica", "normal");
                const giftLines = doc.splitTextToSize(gift, 70);
                doc.text(giftLines, 152, boxY + 20, { align: "center" });

                rightColumnEndY = boxY + boxHeight;
            }
        }

        // === Determine bottom of both columns ===
        const maxColumnY = Math.max(leftTableEndY, rightColumnEndY);
        let curY = maxColumnY + 15; // Start next section below tallest column

        // Optional: Add page if content is near bottom
        const pageHeight = doc.internal.pageSize.height;
        if (curY > pageHeight - 60) {
            doc.addPage();
            curY = 20;
        }

        // ────────────────────── 5. Scheme Details ──────────────────────
        if (detail?.description) {
            doc.setFontSize(13);
            doc.setFont("helvetica", "bold");
            doc.setTextColor(...primary);
            doc.text("Scheme Details", 20, curY);
            curY += 7;

            const wrappedText = doc.splitTextToSize(detail.description, 170);
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(...midText);
            doc.text(wrappedText, 20, curY);
            curY += wrappedText.length * 4.5 + 10; // Approx line height
        }

        // Optional: Page break before CTA if needed
        if (curY > pageHeight - 70) {
            doc.addPage();
            curY = 20;
        }

        // ────────────────────── 6. Call-to-Action Banner ──────────────────────
        doc.setFillColor(...primary);
        doc.rect(20, curY, 170, 18, "F");

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text("PLACE YOUR ORDER TODAY!", 105, curY + 12, { align: "center" });

        curY += 28;

        // ────────────────────── 7. Closing Note ──────────────────────
        doc.setFontSize(11);
        doc.setFont("helvetica", "italic");
        doc.setTextColor(...darkText);
        const closing = doc.splitTextToSize(
            "Thank you for your continued partnership. We look forward to serving you with excellence.",
            170
        );
        doc.text(closing, 105, curY, { align: "center" });
        curY += closing.length * 5 + 15;

        // ────────────────────── 9. Regards Section (new) ──────────────────────
        const fromScp = scheme.fromscp || "Your SCP Partner";

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(...primary);
        doc.text("Regards,", 20, curY);
        curY += 8;

        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(...darkText);
        doc.text(fromScp, 20, curY);
        curY += 15;

        // ────────────────────── 10. Footer ──────────────────────
        const footerY = 285;
        doc.setFillColor(...primary);
        doc.rect(0, footerY, 210, 22, "F");

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(9);
        doc.text("Developed by : Shubham Automation Pvt. Ltd.", 105, footerY + 8, { align: "center" });

        // ────────────────────── 9. Save PDF ──────────────────────
        const fileName = `${safeName(scheme.schemeName)}_${safeName(scp)}_Offer.pdf`;
        doc.save(fileName);
    };

    const handlePdfClick = (scheme) => {
        if (!scheme.scps || scheme.scps.length === 0) {
            alert("No SCPs assigned to this scheme.");
            return;
        }
        scheme.scps.forEach(scp => generatePdfForScp(scheme, scp));
    };

    useEffect(() => {
        let list = schemes;

        // ---------- Helper: substring match for scheme-type ----------
        const typeLabels = { "1": "Discount", "2": "Free Product", "3": "Gift Article" };
        const matchType = txt => {
            const lower = txt.toLowerCase().trim();
            if (!lower) return null;
            if (["1", "2", "3"].includes(lower)) return lower;
            for (const [v, l] of Object.entries(typeLabels))
                if (l.toLowerCase().includes(lower)) return v;
            return null;
        };

        // ---------- FIRST FILTER ----------
        if (firstFilter) {
            if (firstFilter === "schemeType" && firstFilterSearch) {
                const m = matchType(firstFilterSearch);
                list = m ? list.filter(s => s.schemeType === m) : [];
            }
            else if (firstFilter === "status" && firstStatusValue) {
                list = list.filter(s => s.SM_Status?.toString() === firstStatusValue);
            }
            else if (firstFilterSearch) {
                list = list.filter(s =>
                    String(s[firstFilter]).toLowerCase().includes(firstFilterSearch.toLowerCase())
                );
            }
        }

        // ---------- SECOND FILTER ----------
        if (secondFilter) {
            if (secondFilter === "schemeType" && secondFilterSearch) {
                const m = matchType(secondFilterSearch);
                list = m ? list.filter(s => s.schemeType === m) : [];
            }
            else if (secondFilter === "status" && secondStatusValue) {
                list = list.filter(s => s.SM_Status?.toString() === secondStatusValue);
            }
            else if (secondFilterSearch) {
                list = list.filter(s =>
                    String(s[secondFilter]).toLowerCase().includes(secondFilterSearch.toLowerCase())
                );
            }
        }

        // ---------- STATUS FILTER ----------
        if (statusFilterSearch) {
            list = list.filter(s => s.SM_Status?.toString() === statusFilterSearch);
        }

        setFilteredSchemes(list);
        setCurrentPage(1);
    }, [
        firstFilter, firstFilterSearch, firstStatusValue,
        secondFilter, secondFilterSearch, secondStatusValue,
        statusFilterSearch,
        schemes
    ]);

    /* ================== MODAL OPENERS ================== */
    const openRegionModal = regions => {
        setRegionNames(regions || []);
        setRegionPopup(true);
    };
    const openScpModal = scps => {
        setScpNames(scps || []);
        setScpPopup(true);
    };
    const openProductModal = products => {
        setProductList(products || []);
        setProductPopup(true);
    };
    const openDetailModal = scheme => {
        setSelectedScheme(scheme);
        setDetailPopup(true);
    };

    /* ================== PAGINATION ================== */
    const idxLast = currentPage * itemsPerPage;
    const idxFirst = idxLast - itemsPerPage;
    const currentItems = filteredSchemes.slice(idxFirst, idxLast);
    const totalPages = Math.ceil(filteredSchemes.length / itemsPerPage);
    const paginate = n => setCurrentPage(n);

    const handleFirstChange = e => {
        const v = e.target.value;
        setFirstFilter(v);
        setFirstFilterSearch("");
        setFirstStatusValue("");
        //setSecondFilterOptions(prev => prev.map(o => ({ ...o, disabled: o.value === v })));
        setSecondFilterOptions(
            baseFilterOptions.map(o => ({
                ...o,
                disabled: o.value === v
            }))
        );
    };
    const handleSecondChange = e => {
        const v = e.target.value;
        setSecondFilter(v);
        setSecondFilterSearch("");
        setSecondFilterSearch("");
        //firstFilterOptions.forEach(o => { if (o.value === v) o.disabled = true; else o.disabled = false; });
        setFirstFilterOptions(
            baseFilterOptions.map(o => ({
                ...o,
                disabled: o.value === v
            }))
        );
    };

    const openSuspendModal = (scheme) => {
        setSelectedScheme(scheme);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setShowAsterisks({});
        setInputValue("");
        setSelectedScheme(null);
    };

    const handleInputChange = (e) => {
        const asterisks = {};

        asterisks.remarks = false;
        setShowAsterisks(asterisks); // Update state to show asterisks   

        setInputValue(e.target.value);
    };

    const handleSuspend = async () => {
        if (!selectedScheme) return;

        const asterisks = {};
        if (inputValue.trim() === '') {
            asterisks.remarks = true;
            setShowAsterisks(asterisks); // Update state to show asterisks
            return;
        }


        try {
            const response = await fetch(`${config.API_URL}/Scheme/suspendScheme`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    SM_ID: selectedScheme.schemeId,
                    SchemeName: selectedScheme.schemeName,
                    Remark: inputValue,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                // Handle API error messages from backend
                toast.error(data.message || "Something went wrong while suspending the scheme.");
                closeModal();
                return;
            }

            toast.success(data.message || "Scheme suspended successfully.");
            fetchSchemes();
            closeModal();

        } catch (error) {
            console.error("Suspend scheme error:", error);
            toast.error("Network error while suspending the scheme.");
            closeModal();
        }
    };

    const renderLabel = (field, label) => {
        return (
            <label className="">
                {label}
                {showAsterisks[field] && <span className="text-danger"> *</span>}
            </label>
        );
    };

    const handleStatusChange = (event) => {

        const statusValue = event.target.value;
        setStatusFilterSearch(statusValue);
        setCurrentPage(1); // Reset to first page when filtering
    };



    if (loading) return;

    return (
        <>
            <ToastContainer style={{ marginTop: "73px", fontSize: "14px", width: "40%" }} />
            <div className="main_container">
                <h4 className="formHeading">Scheme Master</h4>

                {/* ================== FILTERS ================== */}
                <div className="filter-container">

                    {/* ---------- FIRST FILTER ---------- */}
                    <div className="select-container_list">
                        <CustomDropdown
                            options={firstFilterOptions}
                            value={firstFilter}
                            onChange={handleFirstChange}
                            name="firstFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                        />
                    </div>

                    {/* text box  OR  status dropdown */}
                    {firstFilter === "status" ? (
                        <div className="select-container_list">
                            <CustomDropdown
                                options={statusOptions}
                                value={firstStatusValue}
                                onChange={handleStatusChange}
                                name="firstStatus"
                                placeholder="--Select Status--"
                                idKey="value"
                                displayKey="label"
                            />
                        </div>
                    ) : (
                        <input
                            type="text"
                            className="search-input"
                            value={firstFilterSearch}
                            onChange={e => setFirstFilterSearch(e.target.value)}
                            placeholder="Search"
                        //disabled={!firstFilter}
                        />
                    )}

                    {/* ---------- SECOND FILTER ---------- */}
                    <div className="select-container_list">
                        <CustomDropdown
                            options={secondFilterOptions}
                            value={secondFilter}
                            onChange={handleSecondChange}
                            name="secondFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                        />
                    </div>

                    {secondFilter === "status" ? (
                        <div className="select-container_list">
                            <CustomDropdown
                                options={statusOptions}
                                value={secondStatusValue}
                                onChange={e => setSecondStatusValue(e.target.value)}
                                name="secondStatus"
                                placeholder="--Select--"
                                idKey="value"
                                displayKey="label"
                            />
                        </div>
                    ) : (
                        <input
                            type="text"
                            className="search-input"
                            value={secondFilterSearch}
                            onChange={e => setSecondFilterSearch(e.target.value)}
                            placeholder="Search"
                        //disabled={!secondFilter}
                        />
                    )}

                    {/* ---------- Third Status FILTER ---------- */}
                    <div className="select-container_list">
                        <CustomDropdown
                            options={statusOptions}
                            value={statusFilterSearch}
                            onChange={handleStatusChange}
                            name="filterStatus"
                            placeholder="--Select Status--"
                            idKey="value"
                            displayKey="label"
                        />
                    </div>

                </div>

                {/* ================== MAIN TABLE ================== */}
                <div className="ptable-wrapper">
                    <table className="ptableClass">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Scheme Name</th>
                                <th>Scheme Type</th>
                                <th>Route Details</th>
                                <th>SCP Details</th>
                                <th>Product Details</th>
                                <th>Scheme Description</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredSchemes.length === 0 ? (
                                <tr><td colSpan={10} className="text-center">No Records Found</td></tr>
                            ) : (
                                currentItems.map((s, i) => (
                                    <tr key={s.schemeId}>
                                        <td>{i + 1 + (currentPage - 1) * itemsPerPage}</td>
                                        <td style={{
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                            maxWidth: "180px"
                                        }}>
                                            {s.schemeName}
                                        </td>

                                        <td>
                                            {s.schemeType === "1"
                                                ? "Discount"
                                                : s.schemeType === "2"
                                                    ? "Free Product"
                                                    : s.schemeType === "3"
                                                        ? "Gift Article"
                                                        : s.schemeType}
                                        </td>

                                        <td>
                                            <img
                                                src={Icon9}
                                                alt="View Route"
                                                title="View Route"
                                                // className="cursor-pointer"
                                                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                onClick={() => openRegionModal(s.regions)}
                                            />
                                        </td>

                                        <td>
                                            <img
                                                src={Icon9}
                                                alt="View SCPs"
                                                title="View SCPs"
                                                // className="cursor-pointer"
                                                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                onClick={() => openScpModal(s.scps)}
                                            />
                                        </td>

                                        <td>
                                            <img
                                                src={Icon9}
                                                alt="View Products"
                                                title="View Products"
                                                // className="cursor-pointer"
                                                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                onClick={() => openProductModal(s.products)}
                                            />
                                        </td>

                                        <td>
                                            <img
                                                src={Icon9}
                                                alt="View Scheme Description"
                                                title="View Scheme Description"
                                                // className="cursor-pointer"
                                                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                onClick={() => openDetailModal(s)}
                                            />
                                        </td>

                                        <td>
                                            {s.SM_Status === 1
                                                ? "Active"
                                                : s.SM_Status === 2
                                                    ? "Inactive"
                                                    : s.SM_Status === 3
                                                        ? <span title={s.SM_SuspendRemark}>Suspend</span>
                                                        : s.SM_Status}
                                        </td>

                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>

                                            {s.SM_Status === 3 ? (
                                                <span style={{ fontWeight: "600", color: "#888" }}>-</span>
                                            ) : (
                                                <div style={{ textAlign: "center", verticalAlign: "middle" }}>

                                                    <img
                                                        src={Icon3}
                                                        alt="Edit"
                                                        title="Edit"
                                                        className="editicon"
                                                        style={{ cursor: "pointer", marginRight: "0px" }}   // 👈 spacing added
                                                        onClick={() => navigate(`/SchemeMaster/${s.schemeId}`)}
                                                    />

                                                    <img
                                                        src={Icon4}
                                                        alt="Suspend"
                                                        title="Suspend"
                                                        className="printicon"
                                                        style={{ cursor: "pointer" }}   // 👈 spacing added
                                                        onClick={() => openSuspendModal(s)}
                                                    />

                                                    {/* <img
                                                        src={Icon8}
                                                        alt="Generate PDF"
                                                        title="Generate PDF for all SCPs"
                                                        className="printicon"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handlePdfClick(s)}
                                                    /> */}
                                                </div>
                                            )}
                                        </td>


                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {isModalOpen && (
                    // <div className="popup_overlay">
                    //     <div className="resetpopup">
                    //         <h1>:: User Confirmation ::</h1>
                    //         <h4>
                    //             Are you sure you want to suspend Scheme : {selectedScheme?.schemeName} ?
                    //         </h4>

                    //         <div className="remark_container">
                    //             <span className='me-3 remark_label'>
                    //                 {renderLabel('remarks', 'Remarks :')}
                    //             </span>
                    //             <textarea
                    //                 type='text'
                    //                 className='remark_text'
                    //                 id="remarks"
                    //                 value={inputValue}
                    //                 onChange={handleInputChange}
                    //                 style={{
                    //                     border: '1px solid #ced4da',
                    //                     padding: '10px',
                    //                     fontSize: '16px',
                    //                     resize: 'none',  // Keep this if you want to prevent resizing
                    //                     overflow: 'auto',  // Enable scrollbars when content overflows
                    //                     transition: 'height 0.3s',
                    //                     borderRadius: "5px",
                    //                     outline: "none"
                    //                 }}
                    //                 placeholder="Enter suspend remark"

                    //             />
                    //         </div>

                    //         <div className="popup_btn_container" style={{ marginTop: "20px" }}>
                    //             <button className="yes_btn" onClick={handleSuspend}>YES</button>
                    //             <button className="no_btn" onClick={closeModal}>NO</button>
                    //         </div>
                    //     </div>
                    // </div>
                    <div className="popup_overlay">
                        <div className="resetpopup">
                            <h1>:: User Confirmation ::</h1>
                            <h4 className="word-wrap">Are you sure you want to suspend this Scheme : {selectedScheme?.schemeName} ?</h4>
                            <div className='remark_container'>
                                <span className='me-3 remark_label'>Remark: {showAsterisks.remarks && <span style={{ color: 'red' }}>*</span>} </span>
                                <textarea
                                    type='text'
                                    className='remark_text'
                                    id="remarks"
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    style={{
                                        border: '1px solid #ced4da',
                                        padding: '10px',
                                        fontSize: '16px',
                                        resize: 'none',  // Keep this if you want to prevent resizing
                                        overflow: 'auto',  // Enable scrollbars when content overflows
                                        transition: 'height 0.3s',
                                        borderRadius: "5px",
                                        outline: "none"
                                    }}
                                    placeholder="Enter suspend remark"

                                />
                            </div>

                            <div className="popup_btn_container" style={{ marginTop: "20px" }}>
                                <button className="yes_btn" onClick={handleSuspend}>YES</button>
                                <button className="no_btn" onClick={closeModal}>NO</button>
                            </div>
                        </div>
                    </div>
                )}


                {/* ================== PAGINATION ================== */}
                {/* {filteredSchemes.length > 0 && ( */}
                <ul className="pagination">
                    <li className={currentPage === 1 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(1)} disabled={currentPage === 1}>First</button>
                    </li>
                    <li className={currentPage === 1 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => (
                        <li key={i} className={currentPage === i + 1 ? "page-item active" : "page-item"}>
                            <button className="page-linkd" onClick={() => paginate(i + 1)}>{i + 1}</button>
                        </li>
                    ))}
                    <li className={currentPage === totalPages || filteredSchemes.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
                    </li>
                    <li className={currentPage === totalPages || filteredSchemes.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(totalPages)} disabled={currentPage === totalPages}>Last</button>
                    </li>
                </ul>
                {/* )} */}

                {/* ================== MODALS ================== */}
                <Modal show={regionPopup} onHide={() => setRegionPopup(false)} size="lg" backdrop="static" centered keyboard={false} animation={false} style={{ backdropFilter: 'blur(1px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                    <Modal.Header closeButton><Modal.Title>Route Details</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <table className="tableClass">
                            <thead><tr><th>Sr. No.</th><th>Route Name</th></tr></thead>
                            <tbody>{regionNames.map((name, idx) => (<tr key={idx}><td>{idx + 1}</td><td>{name}</td></tr>))}</tbody>
                        </table>
                        {regionNames.length === 0 && <p className="text-center">No regions assigned.</p>}
                    </Modal.Body>
                </Modal>

                <Modal show={scpPopup} onHide={() => setScpPopup(false)} size="lg" backdrop="static" centered keyboard={false} animation={false} style={{ backdropFilter: 'blur(1px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                    <Modal.Header closeButton><Modal.Title>SCP Details</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <table className="tableClass">
                            <thead><tr><th>Sr. No.</th><th>SCP Name</th></tr></thead>
                            <tbody>{scpNames.map((name, idx) => (<tr key={idx}><td>{idx + 1}</td><td>{name}</td></tr>))}</tbody>
                        </table>
                        {scpNames.length === 0 && <p className="text-center">No SCPs assigned.</p>}
                    </Modal.Body>
                </Modal>

                <Modal show={productPopup} onHide={() => setProductPopup(false)} size="lg" backdrop="static" centered keyboard={false} animation={false} style={{ backdropFilter: 'blur(1px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                    <Modal.Header closeButton><Modal.Title>Product Details</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <table className="tableClass">
                            <thead><tr><th>Sr. No.</th><th>Product Name</th><th>Quantity</th></tr></thead>
                            <tbody>{productList.map((p, idx) => (<tr key={idx}><td>{idx + 1}</td><td>{p.name}</td><td>{p.quantity}</td></tr>))}</tbody>
                        </table>
                        {productList.length === 0 && <p className="text-center">No products in this scheme.</p>}
                    </Modal.Body>
                </Modal>

                <Modal show={detailPopup} onHide={() => setDetailPopup(false)} size="lg" backdrop="static" centered keyboard={false} animation={false} style={{ backdropFilter: 'blur(1px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                    <Modal.Header closeButton><Modal.Title>Scheme Description</Modal.Title></Modal.Header>
                    <Modal.Body>
                        {selectedScheme ? (
                            (() => {
                                const d = selectedScheme.schemeDetails?.[0];
                                if (!d) return <p>No details available.</p>;

                                const rows = [];
                                if (d.description) rows.push({ label: "Description", value: d.description });
                                if (selectedScheme.SM_Status === 3 && selectedScheme.SM_SuspendRemark) {
                                    rows.push({ label: "Suspend Remark", value: selectedScheme.SM_SuspendRemark });
                                }

                                switch (selectedScheme.schemeType) {
                                    case "1":
                                        rows.push({ label: "Discount", value: `${d.discountPercentage}` });
                                        break;
                                    case "2":
                                        d.freeProducts?.forEach((fp, i) => {
                                            rows.push({ label: `Free Product ${i + 1}`, value: `${fp.name} (Quantity : ${fp.quantity})` });
                                        });
                                        break;
                                    case "3":
                                        rows.push({ label: "Gift Article", value: d.giftArticle || "N/A" });
                                        break;
                                    default:
                                        break;
                                }

                                return rows.length ? (
                                    <table className="tableClass">
                                        <thead><tr><th>Scheme Type</th><th>Value</th></tr></thead>
                                        <tbody>{rows.map((r, i) => (<tr key={i}><td><strong>{r.label}</strong></td><td>{r.value}</td></tr>))}</tbody>
                                    </table>
                                ) : (
                                    <p>No details available.</p>
                                );
                            })()
                        ) : (
                            <p>Loading…</p>
                        )}
                    </Modal.Body>
                </Modal>
            </div>

            <Link to={`/SchemeMaster`}>
                <button type="button" className="back_btn">BACK</button>
            </Link>
        </>
    );
};

export default SchemeList;